import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import OutsideClick from '@gorangajic/react-outside-click';
import { Fill } from 'react-slot-fill';
import { ScrollLocky } from 'react-scroll-locky';
import { isFunction } from 'lodash';
import styles from './Modal.css';
import KeyTrap from '../KeyTrap';
import getUniqueId from '../../utils/getUniqueId';
import { trapFocus } from '../../utils/focusUtils';


export const Modal = ({
    onClose,
    children,
    containerStyles,
    className,
    closeOnKeys,
    fill,
    open,
    ariaLabel,
    ...props
}) => {
    if (!open && !fill) {
        return null;
    }
    const [modalId] = useState(getUniqueId('modal'));
    const triggerRef = useRef(null);
    useEffect(() => {
        let cleanup = false;
        if (open) {
            triggerRef.current = document.activeElement;
            cleanup = trapFocus({ id: modalId });
        } else {
            if (
              triggerRef &&
              triggerRef.current &&
              isFunction(triggerRef.current.focus)
            ) {
                triggerRef.current.focus();
            }
            if (isFunction(cleanup)) cleanup();
        }
    }, [open]);
    const modal = (
      <ScrollLocky>
        <div
          className={styles.wrap}
          role="dialog"
          tabIndex="-1"
          aria-label={ariaLabel}
          aria-live="assertive"
        >
          <div id={modalId} className={styles.container} role="document">
            <OutsideClick style={containerStyles} onOutsideClick={onClose}>
              <div {...props} className={className}>
                {children}
              </div>
            </OutsideClick>
            <KeyTrap on={closeOnKeys} handleEvent={onClose} />
          </div>
        </div>
      </ScrollLocky>
    );
    if (fill) {
        return (<Fill name={fill}>
            {open ? modal : null}
        </Fill>);
    }
    return modal;
};

Modal.propTypes = {
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    open: PropTypes.bool.isRequired,
    containerStyles: PropTypes.object,
    closeOnKeys: PropTypes.array,
    fill: PropTypes.string,
    ariaLabel: PropTypes.string,
};

Modal.defaultProps = {
    onClose: () => ({}),
    containerStyles: {},
    className: '',
    closeOnKeys: ['esc'],
};

export default Modal;



// WEBPACK FOOTER //
// ./src/client/Components/Modal/Modal.js